import React from 'react';
import {Link} from 'react-router-dom';

const DefaultButton = ({
                         label,
                         link,
                         to,
                         onClick,
                         bgColor,
                         bgColorHover,
                         textColor,
                         disabled = false,
                         xs = false,
                         sm = false,
                         width = 'flex w-full',
                         rounded = 'rounded-md',
                         ...props
                       }) => {
  let sizingClasses = 'py-2 px-4 text-sm';
  if (xs) {
    sizingClasses = 'py-1 px-2 text-xs';
  }
  if (sm) {
    sizingClasses = 'py-2 px-3 text-xs';
  }

  const className = `group relative ${width} justify-center border border-transparent font-medium ${rounded} ${
    textColor || 'text-white'
  } ${sizingClasses} 
  ${disabled ? 'bg-gray-400' : bgColor || 'bg-gradient-to-r from-cyan-600 from-10% via-sky-800 via-30% to-blue-800 to-90%'}  ${
    disabled ? '' : bgColorHover || 'hover:bg-gradient-to-r hover:from-cyan-600 hover:from-10% hover:via-sky-900 hover:via-30% hover:to-blue-900 to-90%'
  } focus:outline-none`;

  if (link) {
    // TODO: check disabled prop on link
    return (
      <Link disabled={disabled} to={to} className={className} {...props}>
        {label}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={className} disabled={disabled} {...props}>
      {label}
    </button>
  );
};

export default DefaultButton;
